(function () {
    'use strict';
    var controllerId = 'attachAdd';
    angular.module('app').controller(controllerId, ['$scope', 'common', 'bootstrap.dialog', 'datacontext', '$uibModalInstance', 'FileUploader', '_', 'tAttach', 'tSource', 'source', 'tAttachId', 'tSourceCode', 'tSourceId', 'sourceId', 'attach',/*'lista'*/'dipendenteId','tSourceCode_def', attachAdd]);

    function attachAdd($scope, common, bDialog, datacontext, $uibModalInstance, FileUploader, _, tAttach, tSource, source, tAttachId, tSourceCode, tSourceId, sourceId, attach, /*lista*/ dipendenteId, tSourceCode_def) {
        
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.attach = {};
        $scope.tAttach = tAttach;
        $scope.tSource = tSource;
        $scope.source = source;
       // $scope.lista = lista;
        $scope.maxKB_Def = 40960;
        $scope.bTitleChanged = false;
        $scope.upload_URL = datacontext.upload_getURL();
        $scope.attach.uploaded = false;
        $scope.bInsert = false;
        $scope.acceptFileTypes = 'application/pdf';
        $scope.msgFilesExt = '';
        $scope.myTAttach = {};
        $scope.dipendenteId = dipendenteId;
        $scope.tSourceCode_def = tSourceCode_def;
        $scope.lista = [];
        getListAttach();
        $scope.deleteAttach = deleteAttach;

        setMaxKB($scope.maxKB_Def);

        if (typeof (attach) == 'undefined') {
            $scope.attach = {};
            $scope.attach.Id = 0;
            $scope.attach.uploaded = false;
            $scope.selectTitle = 'Seleziona File';
            $scope.popupTitle = 'Nuovo Allegato';
            $scope.action = 'Add';
        } else {
            $scope.attach = jQuery.extend({}, attach);
            $scope.attach.uploaded = true;
            $scope.selectTitle = 'InfoAllegato' + ' ' + $scope.attach.Name + '. ' + 'InfoAllegato2';//'InfoAllegato' +' ' + $scope.attach.Name + '. ' +'InfoAllegato2';
            //($translate.instant('ErroreFormato'))
            $scope.popupTitle = 'Modifica Allegato';
            $scope.action = 'Edit';
        }

        //console.info('attach', attach);

        if (tSourceId) {
            $scope.tSourceId = tSourceId;
            $scope.attach.TSourceId = tSourceId;
            $scope.attach.TSourceName = $scope.tSource[0].Name;
        }

        if (tSourceCode) {
            $scope.tSourceCode = tSourceCode;
            $scope.attach.TSourceName = $scope.tSource[0].Name;
            if (!source) {
                getListSource(tSourceCode);
            }
        }

        if (typeof ($scope.attach.TSourceName) == 'undefined') {
            $scope.attach.TSourceName = 'Riferimento';
        }

        if (sourceId) {
            $scope.sourceId = sourceId;
            $scope.attach.SourceId = sourceId;
        }

        if (tAttachId) {
            $scope.tAttachId = tAttachId;
            $scope.attach.TAttachId = tAttachId;            
            $scope.myTAttach = _.find($scope.tAttach, { 'Id': tAttachId });

            if (typeof ($scope.myTAttach) != 'undefined') {
                $scope.tAttachName = $scope.myTAttach.Name;

                setTAttachParams($scope.myTAttach);
            }


        }
        else {
            //se tAttach non � definito carico solo quelli non ancora presenti a sistema
            getTAttach(tSourceCode, sourceId, $scope.attach.TAttachId);
        }        

        //Gestione Bit1: SI o NO
        $scope.checkBit1_click = function () {
            switch ($scope.myTAttach.checkBit1) {
                case 1: //SI
                    $scope.attach.Bit1 = true;
                    break;
                case 2: //NO
                    $scope.attach.Bit1 = false;
                    break;
            }
        };        

        function setTAttachParams(myTAttach) {
            console.dir(myTAttach);
            //1) Definisco se si hanno le autorizzazioni per inserire
            $scope.bInsert = myTAttach.bInsert;
            //2) Definisco i tipi di file ammessi
            setMaxKB(myTAttach.MaxKB);
            //3) Definisco la dimensione massima consentita
            setListFileTypes(myTAttach.FileType);
        }

        function setListFileTypes(fileTypes) {
            var str = '';
            var arrExt = [];

            //Inizializzo la variabile msgFilesExt
            $scope.msgFilesExt = '';

            if ($.isNumeric(fileTypes))
                return;

            fileTypes.forEach(function (item) {
                str += item.Title + ', ';
                arrExt.push(item.Extension);
            });

            var arrExtAfter = _.map(
                _.uniq(
                    _.map(arrExt, function (obj) {
                        return JSON.stringify(obj);
                    })
                ), function (obj) {
                    return JSON.parse(obj);
                }
            );

            var strExt = arrExtAfter.join(", ");

            //Remove last comma and white space
            str = str.replace(/,\s*$/, "");
            strExt = strExt.replace(/,\s*$/, "");

            if (str.length > 0) {
                $scope.acceptFileTypes = str;
            }

            if (strExt.length > 0) {
                $scope.msgFilesExt = strExt;
            }

            return $scope.acceptFileTypes;
        }



        function setMaxKB(MaxKB) {
            $scope.maxKB = MaxKB == 0 ? $scope.maxKB_Def : MaxKB;

            if ($scope.maxKB >= 1024)
                $scope.MaxDim = parseInt(($scope.maxKB / 1024)) + ' MB';
            else if ($scope.maxKB < 1024)
                $scope.MaxDim = parseInt(($scope.maxKB)) + ' KB';

            //console.info('maxKB', item, $scope.maxKB);
            return $scope.maxKB;
        }


        /*
        $scope.getListFileTypes = function (tAttachId, title, extension) {
            $scope.msgFilesExt = '';
            return datacontext.tAttachFileType_getAll(tAttachId, title, extension).then(function (data) {
                return setListFileTypes_new(data);
            });
        }  
        */
        function getListAttach() {
            if (!$scope.dipendenteId) return;

            return datacontext.attach_getAll(0, 0, $scope.tSourceCode_def, 0, $scope.dipendenteId, $scope.tAttach.Id, '').then(function (data) {
                //vm.list.b_attach = true;
                return $scope.lista = data;
            });
        }

        function deleteAttach(item) {
            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError('Attenzione: allegato non cancellabile! Contattare l\'Help-desk');

                    var index = $scope.lista.indexOf(item);
                    $scope.lista.splice(index, 1);
                    //vm.record.stat_numAttach = vm.record.stat_numAttach - 1;
                });
            });
        }

        $scope.ok = function () {          
                //console.info("ok", $scope.attach);
            var result = addItem($scope.attach);
            
                //$uibModalInstance.close(result);           
        };

        $scope.cancel = function () {
            $uibModalInstance.close(true);
        };

        function addItem(item) {
            if ($scope.action == 'Add') {                
                item.Title = $scope.attach.Name;                
                return datacontext.attach_add(item).then(function (data) {
                    if (!data) return null;
                    if (data == "400") return null;
                    if (data) {
                        $scope.removeFile();
                        logSuccess('Allegato aggiunto con successo ');
                    }

                    getListAttach();
                    return data;
                });
            } else if ($scope.action == 'Edit') {
                return datacontext.attach_update(item).then(function (data) {
                    if (!data) return null;
                    if (data == "400") return null;

                    return data;
                });
            }
        }

        $scope.TSourceChanged = function () {
            var tSourceId = $scope.attach.TSourceId;
            $scope.source = [];
            $scope.attach.SourceId = 0;
            $scope.tAttach = [];
            $scope.attach.TAttachId = 0;
            return datacontext.tSource_get(tSourceId).then(function (data) {
                $scope.tSourceCode = data.Code;
                getListSource(data.Code);
            });

            return false;
        };

        $scope.SourceChanged = function () {
            $scope.tAttach = [];
            $scope.attach.TAttachId = 0;
            getTAttach($scope.tSourceCode, $scope.attach.SourceId);

            return false;
        };

        function getTAttach(tSourceCode, sourceId, tAttachId) {
            var onlyMissing = 1;
            if ($scope.tAttach == null)
                $scope.tAttach = [];

            //return datacontext.tAttach_getAllList(tSourceCode, 0, sourceId, onlyMissing, tAttachId).then(function (data) {
            return datacontext.tAttach_getAllModal(tSourceCode, 0, sourceId, onlyMissing, tAttachId).then(function (data) {
                var listTA = data;

                return datacontext.tAttachVisibility_getAuth(tSourceCode).then(function (data) {

                    var tAttach_auth = data;
                    tAttach_auth.forEach(function (item_TAV) {

                        var myrec = _.find(listTA, { 'Id': item_TAV.TAttachId });
                        //console.info('myrec-prima', myrec);

                        if (typeof (myrec) != 'undefined') {

                            myrec.bRead = item_TAV.bRead;
                            myrec.bInsert = item_TAV.bInsert;
                            myrec.bUpdate = item_TAV.bUpdate;
                            myrec.bDelete = item_TAV.bDelete;
                            myrec.iTags = item_TAV.iTags;
                            if (myrec.bRead)
                                $scope.tAttach.push(myrec);
                            //console.info('myrec', myrec);
                        }
                    });
                });
                //console.info('tAttach', $scope.tAttach, listTA);
                return $scope.tAttach;
            });
        }

        $scope.changeTAttach = function (tAttachId) {
            if (!tAttachId) return;

            $scope.myTAttach = _.find($scope.tAttach, { 'Id': tAttachId });
            //In base al tipo di file selezionato:

            if (typeof ($scope.myTAttach) != 'undefined') {//if (typeof ($scope.myTAttach) == 'undefined') {
                setTAttachParams($scope.myTAttach);
            }

            if ($scope.myTAttach.iBit1 > 0)
                $scope.myTAttach.checkBit1 = 0;

            //console.info('$scope.myTAttach', $scope.myTAttach);

            return $scope.bInsert;
        };

        /*
        function getTAttach(tSourceCode, sourceId, tAttachId) {
        	var onlyMissing = 1;
            return datacontext.tAttach_getAllList(tSourceCode, 0, sourceId, onlyMissing, tAttachId).then(function (data) {
        		return $scope.tAttach = data;
        	});
        }
        */

        function getListSource(tSourceCode) {
            return datacontext.source_getAllList(tSourceCode).then(function (data) {
                return $scope.source = data;
            });
        }

        $scope.TitleChanged = function () {
            $scope.bTitleChanged = true;
            return false;
        };

        $scope.removeFile = function (item) {            
            $scope.attach.Path = '';
            $scope.attach.Name = '';
            $scope.attach.KB = 0;
            $('#inputFile').val("");

            $scope.attach.uploaded = false;
            return false;
        };

        // FILTERS
        var uploader = $scope.uploader = new FileUploader({
            url: $scope.upload_URL,
            removeAfterUpload: true
        }
        );

        uploader.filters.push({
            name: 'customFilter',
            fn: function (item /*{File|FileLikeObject}*/, options) {
                return this.queue.length < 10;
            }
        });

        // CALLBACKS

        uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
            /*
        	console.info('onWhenAddingFileFailed', item, filter, options);
        	console.log('onWhenAddingFileFailed - end');
            */
        };
        uploader.onAfterAddingFile = function (fileItem) {
            /*
        	console.info('onAfterAddingFile', fileItem);
        	console.log('onAfterAddingFile - end');
        	console.dir(fileItem);
            */
        };
        uploader.onAfterAddingAll = function (addedFileItems) {
            /*
        	console.info('onAfterAddingAll', addedFileItems);
        	console.log('onAfterAddingAll - end');
            */
        };
        uploader.onBeforeUploadItem = function (item) {
            /*
            console.info('onBeforeUploadItem', item);
            console.log('onBeforeUploadItem');
            */
        };
        uploader.onProgressItem = function (fileItem, progress) {
            /*
            console.info('onProgressItem', fileItem, progress);
        	console.log('onProgressItem - end');
        	console.dir(progress);
            */
        };
        uploader.onProgressAll = function (progress) {
            /*
        	console.info('onProgressAll', progress);
        	console.log('onProgressAll - end');
            */
        };
        uploader.onSuccessItem = function (fileItem, response, status, headers) {
            //console.info('onSuccessItem', fileItem, response, status, headers);
            //console.log('onSuccessItem - end');
            //console.info("response", response);
            if (response != null && response.length > 0) {
                var data = response[0];
                $scope.attach.Path = data.PathServer;
                //console.dir(data.PathServer);
                $scope.attach.Name = data.NameOrig;
                $scope.attach.KB = data.Length;
                $scope.attach.uploaded = true;
                $scope.ok();
            }

        };
        uploader.onErrorItem = function (fileItem, response, status, headers) {
            /*
            console.info('onErrorItem', fileItem, response, status, headers);
        	console.log('onErrorItem - end');
            */
        };
        uploader.onCancelItem = function (fileItem, response, status, headers) {
            /*
        	console.info('onCancelItem', fileItem, response, status, headers);
        	console.log('onCancelItem - end');
            */
        };
        uploader.onCompleteItem = function (fileItem, response, status, headers) {
            /*
        	console.info('onCompleteItem', fileItem, response, status, headers);
        	console.log('onCompleteItem - end');
            */
        };
        uploader.onCompleteAll = function () {
            /*
        	console.info('onCompleteAll');
        	console.log('onCompleteAll - end');
            */
        };

        //console.info('uploader', uploader);


    }
})();